"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateShiftAttributeCreate = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const error_handler_1 = require("@app/util/error-handler");
const apollo_1 = require("@app/util/apollo");
const query = (0, graphql_tag_1.default) `mutation ShiftAttributeCreateMutation (
  $workspace: ID!,
  $name: String!,
  $shortName: String!,
  $type: CustomAttributeValueType!
  $options: CustomAttributeOptionsInput,
  $customId: String,
  $description: String
) {
  shiftAttributeCreate (
    workspace: $workspace,
    name: $name,
    shortName: $shortName,
    type: $type,
    options: $options,
    customId: $customId,
    description: $description
  ) {
    id
    name
    description
    shortName
    customId
    type
    options {
      values
      countTowardsPeriod
    }
    hidden
  }
}`;
const mutateShiftAttributeCreate = async (args) => {
    const { data, errors } = await (0, apollo_1.mutate)(query, {
        variables: args
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.shiftAttributeCreate;
};
exports.mutateShiftAttributeCreate = mutateShiftAttributeCreate;
exports.default = exports.mutateShiftAttributeCreate;
